import { Component, Input, OnInit } from '@angular/core';
import { AbstractInputComponent } from '../abstract-input.component';
import { ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyInputComponent } from '../empty-input/empty-input.component';

@Component({
  selector: 'common-text-input',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    EmptyInputComponent,
  ],
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
})
export class TextInputComponent
  extends AbstractInputComponent
  implements OnInit
{
  @Input()
  public maxLength: number;

  @Input()
  public minLength: number;

  protected override createValidators(): ValidatorFn[] {
    const validators = super.createValidators();
    if (this.maxLength !== undefined) {
      validators.push(Validators.maxLength(this.maxLength));
    }
    if (this.minLength !== undefined) {
      validators.push(Validators.minLength(this.minLength));
    }
    return validators;
  }
}
